require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./brexit-call-for-collaboration.json") })
        }
      }, "path---brexit-call-for-collaboration");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---brexit-call-for-collaboration!./.cache/json/brexit-call-for-collaboration.json
// module id = 327
// module chunks = 231608221292675